<template>
    <v-flex xs12 fill-height>
        <v-container fluid grid-list-sm class="filter">
            <v-layout row wrap>
                <v-flex xs12>
                    <v-select
                            :items="getServiceList()"
                            :placeholder="$vuetify.t('$vuetify.Statistics.servicePlaceholder')"
                            color="secondary"
                            background-color="primary"
                            hide-details
                            solo
                            v-model="service">
                    </v-select>
                </v-flex>
                <v-flex xs6>
                    <v-text-field
                            autocomplete="new-password"
                            append-icon="mdi-calendar-range"
                            v-model="dateFrom"
                            :placeholder="$vuetify.t('$vuetify.Statistics.dateFromPlaceholder')"
                            background-color="primary"
                            color="secondary"
                            hide-details
                            solo
                            @focus="showDateFromPopup= true"
                            readonly>
                    </v-text-field>
                </v-flex>
                <v-flex xs6>
                    <v-text-field
                            autocomplete="new-password"
                            append-icon="mdi-calendar-range"
                            v-model="dateTo"
                            :placeholder="$vuetify.t('$vuetify.Statistics.dateToPlaceholder')"
                            background-color="primary"
                            color="secondary"
                            hide-details
                            solo
                            @focus="showDateToPopup= true"
                            readonly>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container v-if="statistics && statistics.edges && statistics.edges.length > 0" fluid pt-0 class="table">
            <v-layout fill-height row wrap>
                <v-flex xs12 class="table-background">
                    <v-data-table
                            :items="statistics.edges"
                            hide-actions
                            class="custom-table">

                        <template v-slot:headers="props">
                            <td class="header_cell">{{
                                $vuetify.t("$vuetify.Statistics.tableHeaders.vehicle")
                                | uppercase }}
                            </td>
                            <td class="header_cell">
                                <v-icon>mdi-calendar-import</v-icon>
                            </td>
                            <td class="header_cell">
                                <v-icon>mdi-calendar-export</v-icon>
                            </td>
                            <td class="header_cell">
                                <v-icon>mdi-clock-outline</v-icon>
                            </td>
                            <td class="header_cell">
                                <v-icon>mdi-map-marker-distance</v-icon>
                            </td>
                            <td class="header_cell">
                                <v-icon>mdi-coin</v-icon>
                            </td>
                        </template>
                        <template v-slot:items="props">

                            <td v-if="props.item.node.vehicle && props.item.node.vehicle.code">{{props.item.node.vehicle.code}}</td>
                            <td v-else ></td>

                            <td v-if="props.item.node.startTime">{{props.item.node.startTime | moment("DD/MM/YYYY HH:mm:ss")}}</td>
                            <td v-else></td>

                            <td v-if="props.item.node.endTime">{{props.item.node.endTime | moment("DD/MM/YYYY HH:mm:ss")}}</td>
                            <td v-else></td>

                            <td v-if="props.item.node.duration">{{props.item.node.duration}}<template v-if="props.item.node.level"> ({{props.item.node.level}})</template></td>
                            <td v-else></td>

                            <td v-if="props.item.node.distanceS">{{props.item.node.distanceS}}</td>
                            <td v-else></td>

                            <td v-if="props.item.node.chargeS">{{props.item.node.chargeS}}</td>
                            <td v-else></td>


                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container v-else flid pt-0 class="no-result">
            {{ $vuetify.t("$vuetify.Statistics.noResult")}}
        </v-container>
        <v-container fluid class="pagination">
            <v-layout row wrap justify-center>
               <v-btn v-if="statistics && statistics.pageInfo && statistics.pageInfo.hasNextPage"
                      color="button-dark"
                      class="button-more"
                      @click="showMore()">
                   {{ $vuetify.t("$vuetify.Statistics.showMore")}}
               </v-btn>
            </v-layout>
        </v-container>
        <v-container v-if="showDateFromPopup || showDateToPopup" d-block
                     class="data-picker-container">
            <v-layout fill-height align-center>
                <v-flex xs12>
                    <v-date-picker v-if="showDateFromPopup" v-model="dateFrom"
                                   @input="showDateFromPopup=false"></v-date-picker>
                    <v-date-picker v-if="showDateToPopup" v-model="dateTo"
                                   @input="showDateToPopup=false"></v-date-picker>
                </v-flex>
            </v-layout>
        </v-container>
    </v-flex>
</template>

<script>

    import {avaiableLanguage} from "../util_const"

    export default {
        name: 'Statistics',
        data() {
            return {
                page: 1,
                dateFrom: null,
                dateTo: null,
                showDateFromPopup: false,
                showDateToPopup: false,
                service: "SHARING_UNIT",
                statistics: {},
                perPageEl: 6,

            }
        },
        apollo: {
            statistics: {
                client: "clientPrivate",
                query: require("../graphql/queries/statistics.gql"),
                variables () {
                    return {
                        tipology: this.service,
                        from_date: this.dateFrom,
                        to_date: this.dateTo,
                        first: this.perPageEl,
                        after: null
                    }
                },
                update(data){
                   return data.sharings

                }

            }
        },
        methods: {
            getServiceList() {
                return [
                    {
                        text: this.$vuetify.t("$vuetify.Statistics.services.sharing_unit"),
                        value: "SHARING_UNIT",
                    },
                    {
                        text: this.$vuetify.t("$vuetify.Statistics.services.car_unit"),
                        value: "CAR_UNIT",
                    },
                    {
                        text: this.$vuetify.t("$vuetify.Statistics.services.recharge_unit"),
                        value: "RECHARGE_UNIT",
                    }
                ]
            },
            showMore() {
                this.$apollo.queries.statistics.fetchMore({

                    variables: {
                        tipology: this.service,
                        from_date: this.dateFrom,
                        to_date: this.dateTo,
                        first: this.perPageEl,
                        after: this.statistics.pageInfo.endCursor
                    },

                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return {
                            sharings: {
                                __typename: previousResult.sharings.__typename,
                                // Merging the tag list
                                edges: [...previousResult.sharings.edges, ...fetchMoreResult.sharings.edges],
                                pageInfo: fetchMoreResult.sharings.pageInfo
                            }
                        }
                    },
                })
            },
        }


    }
</script>


<style scoped lang="scss">

    .table {
        height: calc(100% - 225px);
        overflow-x: hidden;
        overflow-y: auto;

        .table-background{
            background-color: var(--v-primary-base);
        }

        .custom-table{
            .header_cell{
                padding: 8px;
                color: var(--v-blueprimary-base)
            }
        }
    }

    .data-picker-container {
        position: fixed;
        top: 0;
        left: 0px;
        height: 100%;
        width: 100%;

    }

    .button-more{
        color: var(--v-primary-base)
    }
</style>